import React from "react";
import { verifylogout } from "../../Model/Users";
import { motion } from "framer-motion";
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { Link } from "react-router-dom";
import Profilemenu from "../Profile_menu/Profilemenu";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import { isMobile } from "react-device-detect";
var SVGIcon = "";
var ImageData = "";

SVGIcons().then((resultData) => (SVGIcon = resultData));
ImgIcons().then((result) => (ImageData = result));

class pinsend extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      PinField: { pin1: "", pin2: "", pin3: "", pin4: "" },
      IvalidpinMsg: "",
      Showpop: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.submitVerifypinForm = this.submitVerifypinForm.bind(this);
  }

  /*------------------Handle Change------------------*/

  handleChange(e) {
    const fields = this.state.PinField;

    this.setState({
      IvalidpinMsg: "",
    });
    if (e.target.name == "pin1") {
      fields["pin1"] = e.target.value;
      this.setState({ fields });
    } else if (e.target.name == "pin2") {
      fields["pin2"] = e.target.value;
      this.setState({ fields });
    } else if (e.target.name == "pin3") {
      fields["pin3"] = e.target.value;
      this.setState({ fields });
    } else if (e.target.name == "pin4") {
      fields["pin4"] = e.target.value;
      this.setState({ fields });
    } else {
    }
  }

  /*-----------Verify Pin Submit Form--------------*/

  submitVerifypinForm(e) {
    e.preventDefault();
    var postdata = {
      logout_sessionid: this.props.data.state.Logoutsessid,
      otp:
        this.state.PinField.pin1 +
        this.state.PinField.pin2 +
        this.state.PinField.pin3 +
        this.state.PinField.pin4,
      type: "verify",
    };

    verifylogout(postdata).then((res) => {
      var VerifyPinResp = JSON.parse(res.data);

      if (VerifyPinResp.success == true) {

        this.setState({
          IvalidpinMsg: VerifyPinResp.message,
          Showpop: true
        });

      } else {
        //this.props.data.popupshow();
        this.setState({
          IvalidpinMsg: VerifyPinResp.message,
          Showpop: false
        });
      }
    });
  }


  headerText() {
    return (
      <div className="homeBanner">
        <div className="innerBanner mb-0">
          <div className="title-reset">
            <h1>
              Verification <span className="red"> code</span>
            </h1>
            <div className="reset">
              Please enter the verification code that we have just sent
              to you on your mobile number. The code will be valid for
              30 minutes.
            </div>
          </div>
        </div>
      </div>
    );
  }

  // formSubmit(){
  //   return();
  // }
  /*----------------------Render----------------------*/

  render() {
    /*------Verify Pin Button Enable disable-------*/

    var Pinstate = this.state.PinField;

    if (Pinstate.pin1 && Pinstate.pin2 && Pinstate.pin3 && Pinstate.pin4) {
      var Button = false;
    } else {
      var Button = true;
    }

    return (
      <>
        <motion.div
          className=""
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
          key="1"
        >
          <div className="temp4 dD-none">
            <hr className="border-red" />
            <hr />
            <div className="temp4-InnerRound50">
              <div className="temp4-InnerRound1">
                <div className="temp4-InnerRound2" />
              </div>
            </div>
            <div className="temp4-InnerRound51">
              <div className="temp4-InnerRound1">
                <div className="temp4-InnerRound2" />
              </div>
            </div>
            <div className="temp4-InnerRound52">
              <div className="temp4-InnerRound3" />
            </div>
          </div>
          <header>
            <div className="mainNav dD-none">
              <div
                onClick={() => {
                  this.props.data.CustomeBackButton();
                }}
                className="docubayBack white pl-8"
              >
                <img src="img/svg/back.svg" alt="DocuBay" /> Manage Device
              </div>
              <div className="topQuestion">
                {/*<img src="img/svg/help.svg" alt="help" />*/}
              </div>
            </div>
          </header>
          <main>
            <section className="mb-0 dD-none">
              {this.headerText()}
            </section>
            <form
              method="post"
              name="verifypin"
              onSubmit={this.submitVerifypinForm}
              noValidate="novalidate"
            >
              <section style={{ paddingBottom: 45 }} className="dD-none">
                <div className="temp31">
                  <div className="temp31Inner">
                    <div className="formField verify-code">
                      <input
                        type="tel"
                        name="pin1"
                        placeholder=""
                        className="text-center"
                        maxLength="1"
                        onChange={this.handleChange}
                      />
                    </div>
                    <div className="formField verify-code">
                      <input
                        type="tel"
                        name="pin2"
                        placeholder=""
                        maxLength="1"
                        className="text-center"
                        onChange={this.handleChange}
                      />
                    </div>
                    <div className="formField verify-code">
                      <input
                        type="tel"
                        name="pin3"
                        placeholder=""
                        maxLength="1"
                        className="text-center"
                        onChange={this.handleChange}
                      />
                    </div>
                    <div className="formField verify-code">
                      <input
                        type="tel"
                        name="pin4"
                        placeholder=""
                        maxLength="1"
                        className="text-center"
                        onChange={this.handleChange}
                      />
                    </div>
                    {this.state.IvalidpinMsg ? (
                      <div className="error error-verifyotp">
                        <img
                          src={process.env.PUBLIC_URL + "img/svg/error.svg"}
                          alt="DocuBay"
                        />
                        <p>{this.state.IvalidpinMsg} </p>
                      </div>
                    ) : null}
                    <div className="formField mt-24 mb-24">
                      <button
                        type="submit"
                        id="sendEnquiryBtn"
                        className="btn-red"
                        disabled={Button}
                        className={Button ? "btn-black" : "btn-red"}
                      >
                        Verify
                      </button>
                    </div>
                    <div
                      className="passChangepopup"
                      style={{
                        display: this.state.Showpop
                          ? "flex"
                          : "none",
                      }}
                      id="passChange"
                    >
                      <div className="temp31-modal-body">
                        <button
                          className="temp31-modal-close temp31-modal-toggle"
                          onClick={() => {
                            this.backbtn();
                          }}
                        >
                          <img
                            src={SVGIcon["promocode-close.svg"]}
                            alt="DocuBay"
                          />
                        </button>
                        <img
                          src={ImageData["manage-devices.png"]}
                          alt="DocuBay"
                          className="imgPass"
                        />
                        <div className="temp31-awesome">
                          <h5>Device Removed!</h5>
                          <h6>Your DocuBay account has been logged out from the device successfully</h6>
                        </div>
                        <Link
                          to="/manage-profile"
                          type="submit"
                          id="sendEnquiryBtn"
                          className="btn-white"
                        >
                          Back to Settings
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </form>
          </main>

          <>
            <div className="mainNav pmenu mainNav-1 dD-block">
              <Link to="/manage-profile">
                <div className="docubayBack white">
                  <img src={SVGIcon["back.svg"]} alt="DocuBay" />
                </div>
              </Link>
              <div className="lastNav-desk inj dD-block">
                <ul>
                  <li>
                    <a href="javascript:void(0)" className="active">
                      <img src={SVGIcon["search-desk.svg"]} style={{ width: '26px' }} />
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <img src={SVGIcon["notifications.svg"]} style={{ width: '26px' }} />
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <main className="setting-main dD-block">
              <div className="temp4">
                <hr className="border-red" />
                <hr />
                <div className="temp4-InnerRound50">
                  <div className="temp4-InnerRound1">
                    <div className="temp4-InnerRound2" />
                  </div>
                </div>
                <div className="temp4-InnerRound51">
                  <div className="temp4-InnerRound1">
                    <div className="temp4-InnerRound2" />
                  </div>
                </div>
                <div className="temp4-InnerRound52">
                  <div className="temp4-InnerRound3" />
                </div>
              </div>
              <section className="mb-0">
                {this.headerText()}
              </section>
              <form
                method="post"
                name="verifypin"
                onSubmit={this.submitVerifypinForm}
                noValidate="novalidate"
              >
                <section style={{ paddingBottom: 45 }}>
                  <div className="temp31">
                    <div className="temp31Inner">
                      <div className="formField verify-code">
                        <input
                          type="tel"
                          name="pin1"
                          placeholder=""
                          className="text-center"
                          maxLength="1"
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="formField verify-code">
                        <input
                          type="tel"
                          name="pin2"
                          placeholder=""
                          maxLength="1"
                          className="text-center"
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="formField verify-code">
                        <input
                          type="tel"
                          name="pin3"
                          placeholder=""
                          maxLength="1"
                          className="text-center"
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="formField verify-code">
                        <input
                          type="tel"
                          name="pin4"
                          placeholder=""
                          maxLength="1"
                          className="text-center"
                          onChange={this.handleChange}
                        />
                      </div>
                      {this.state.IvalidpinMsg ? (
                        <div className="error error-verifyotp">
                          <img
                            src={process.env.PUBLIC_URL + "img/svg/error.svg"}
                            alt="DocuBay"
                          />
                          <p>{this.state.IvalidpinMsg} </p>
                        </div>
                      ) : null}
                      <div className="formField mt-24 mb-24">
                        <button
                          type="submit"
                          id="sendEnquiryBtn"
                          className="btn-red"
                          disabled={Button}
                          className={Button ? "btn-black" : "btn-red"}
                        >
                          Verify
                        </button>
                      </div>
                      <div
                        className="passChangepopup"
                        style={{
                          display: this.state.Showpop
                            ? "flex"
                            : "none",
                        }}
                        id="passChange"
                      >
                        <div className="temp31-modal-body">
                          <button
                            className="temp31-modal-close temp31-modal-toggle"
                            onClick={() => {
                              this.backbtn();
                            }}
                          >
                            <img
                              src={SVGIcon["promocode-close.svg"]}
                              alt="DocuBay"
                            />
                          </button>
                          <img
                            src={ImageData["manage-devices.png"]}
                            alt="DocuBay"
                            className="imgPass"
                          />
                          <div className="temp31-awesome">
                            <h5>Device Removed!</h5>
                            <h6>Your DocuBay account has been logged out from the device successfully</h6>
                          </div>
                          <Link
                            to="/manage-profile"
                            type="submit"
                            id="sendEnquiryBtn"
                            className="btn-white"
                          >
                            Back to Settings
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </form>
            </main>
          </>
          {isMobile ? <Mobilemenu active="5" /> : <Profilemenu userdata={this.state.userData} />}
        </motion.div>
      </>
    );
  }
}
export default pinsend;
